import React from 'react';
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom';
import {AuthProvider} from './context/AuthContext';
import {UserProvider} from './context/UserContext';
import {RoleProvider} from './context/RoleContext';
import {PairDataProvider} from './context/PairDataContext';
import {ThemeProvider} from './context/ThemeContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import ExplorePairs from './pages/ExplorePairs';
import DailyDraw from './pages/DailyDraw';
import Favorites from './pages/Favorites';
import CuratedPairs from './pages/CuratedPairs';
import Upgrade from './pages/Upgrade';
import Login from './pages/Login';
import Register from './pages/Register';
import Admin from './pages/Admin';
import AdminDashboard from './pages/AdminDashboard';
import UserManagement from './pages/UserManagement';
import ContentManagement from './pages/ContentManagement';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <RoleProvider>
          <UserProvider>
            <PairDataProvider>
              <Router>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/explore" element={<ExplorePairs />} />
                    <Route path="/daily-draw" element={<DailyDraw />} />
                    <Route path="/favorites" element={<Favorites />} />
                    <Route path="/curated" element={<CuratedPairs />} />
                    <Route path="/upgrade" element={<Upgrade />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/admin/dashboard" element={<AdminDashboard />} />
                    <Route path="/admin/users" element={<UserManagement />} />
                    <Route path="/admin/content" element={<ContentManagement />} />
                  </Routes>
                </Layout>
              </Router>
            </PairDataProvider>
          </UserProvider>
        </RoleProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;